module.exports = __webpack_public_path__ + "static/media/banana2.fa5c1238.png";